"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * A collection of details
 * @param {number} count the number of details returned
 * @param {string} lastKey the pagination key for the last item
 * @param {Array.<Detail>} type the details of the given type
 */


var Details = function Details(fields, type) {
  (0, _classCallCheck3.default)(this, Details);

  if (!fields) {
    return;
  }

  if (fields.count) {
    this.count = fields.count;
  }

  if (fields[type]) {
    this[type] = fields[type];
  }

  if (fields.lastKey) {
    this.lastKey = fields.lastKey;
  }
};

exports.default = Details;